<template>
  <v-navigation-drawer permanent absolute style="padding-top: 64px">
    <default-list :items="items" />
  </v-navigation-drawer>
</template>

<script>
import {sync} from "vuex-pathify";

export default {
  name: "AppDetailsDrawer",
  components: {
    DefaultList:() => import(
        '@/layouts/default/List'
        )
  },
  computed: {
    currentApp: sync('application/currentApp'),
    items() {
      return [
        {
          title: 'Setting',
          icon: 'mdi-cog-outline',
          to: `/applications/${this.currentApp.id}/settings`,
        },
        {
          title: 'Link Bot',
          icon: 'mdi-link-variant',
          to: `/applications/${this.currentApp.id}/link-bot`,
        },
        {
          title: 'Webhook',
          icon: 'mdi-webhook',
          to: `/applications/${this.currentApp.id}/webhook`,
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
